module.exports = "<div data-component=\"preloader\">\n\t<div class=\"spinner\">\n\t\t<mat-spinner diameter=\"64\"></mat-spinner>\n\t</div>\n\t<div class=\"overlay\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/preloader/preloader.component.html
// module id = ../../../../../src/app/shared/preloader/preloader.component.html
// module chunks = main